'use client';

import React from 'react';
import WarrantyRegistrationSlider,{WarrantyRegistrationProps} from 'components/commercetools-ui/organisms/warrantyregistration';
import { TasticProps } from 'frontastic/tastics/types';


const WarrantyRegistrationTastic  = ({ data }: TasticProps<WarrantyRegistrationProps>) => {
    
    return <WarrantyRegistrationSlider data={data?.data?.dataSource}  />;
};

export default WarrantyRegistrationTastic;